import { BaseRestApiEndpoint, ERestApiMethod } from "utils/api";
import { IMyOffer } from "utils/offer";

type TInput = void;
type TOutput = Array<IMyOffer>;

export default class MyOffersApiEndpoint extends BaseRestApiEndpoint<
  TInput,
  TOutput
> {
  method = ERestApiMethod.GET;

  resolveUri(): string {
    return `/fe-api/my-offers`;
  }

  mapResponseData(_status: number, data: any): TOutput {
    return data.offers.map(
      (x: any): IMyOffer => ({
        id: x.id,
        offerTypeId: x.offer_type_id,
        status: x.status,
        absoluteUrl: x.absolute_url,
        seo: x.seo,
        dispositionId: x.disposition_id,
        publishedAt: x.publish_date,
        photos: x.photos,
        numNotifications: x.num_notifications,
        street: x.street,
        village: x.village,
        villagePart: x.village_part,
        area: x.acreage,
        paymentExpiration: x.paid_expiration_day,
        paidTypeId: x.paid_type_id,
      }),
    );
  }
}
